import React from 'react';
import "./InfoBox.css";
import { Card, CardContent, Typography } from "@material-ui/core";

function InfoBox({ title, active, isRed, isBlack, cases, total, ...props }) {
    return (
            <Card className={`infoBox ${active && "infoBox--selected"} ${isRed && "infoBox--red"} ${isBlack && "infoBox--black"}`} 
            onClick={props.onClick}> 
                <CardContent>
                    {/* Title */}
                    <Typography className="infoBox__title" color="textSecondary">
                        {title}
                    </Typography>

                    {/* Number of daily cases */}
                    <h2 className={`infoBox__cases ${(!isRed && !isBlack &&"infoBox__cases--green")} ${(isBlack &&"infoBox__cases--black")}`}>{cases}</h2>

                    {/* Total cases */}
                    <Typography className="infoBox__total" color="textSecondary">
                        {total} Total
                    </Typography>

                </CardContent>
            </Card>
    )
}

export default InfoBox
